import React from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useSelector, useDispatch } from "react-redux";

import { Box, Typography } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { animateScroll as scroll } from "react-scroll";
import TicketRequests from "services/tickets";
import TicketsTableHeading from "./TicketsTableHeading";
import TicketsTableItem from "./TicketTableItem";

const TicketsTable = () => {
    const { tickets, ticketsCurrentPage, ticketsTotalPages, ticketsStatus } = useSelector(
        ({ tickets }) => tickets
    );
    const dispatch = useDispatch();

    const handleChangePagination = (_, value) => {
        dispatch(TicketRequests.getAllTickets(value, ticketsStatus));
        scroll.scrollToTop();
    };

    return (
        <div className="Cmt-table-responsive">
            {tickets && tickets.length === 0 ? (
                <Box
                    display={"flex"}
                    justifyContent={"center"}
                    paddingTop={"30px"}
                    paddingBottom={"20px"}
                >
                    <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
                </Box>
            ) : (
                <Table>
                    <TableHead>
                        <TicketsTableHeading />
                    </TableHead>
                    <TableBody>
                        {tickets.map((item) => (
                            <TicketsTableItem
                                row={item}
                                key={item._id}
                            />
                        ))}
                    </TableBody>
                </Table>
            )}
            {tickets.length !== 0 ? (
                <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
                    <Pagination
                        count={ticketsTotalPages}
                        color="primary"
                        page={ticketsCurrentPage}
                        onChange={handleChangePagination}
                    />
                </Box>
            ) : null}
        </div>
    );
};

export default TicketsTable;